import React, { useState, useEffect, useRef } from "react";
import "./About.css";
import Popup from "../components/popup.js";
import { Client, Databases, ID } from "appwrite";
import recright from "../assets/Home/recright.webp";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import config from "../config/config";
import { useLocation } from 'react-router-dom';

// Inside your about-us component:

const Platform = ({utmContent}) => {
  useEffect(() => {
    // Set page title
    document.title = "Platform | Random Walk";

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation.";
      document.head.appendChild(meta);
    }

    // Add or update Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", "Platform | Random Walk");

    // Add or update Open Graph description
    let ogDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!ogDescription) {
      ogDescription = document.createElement("meta");
      ogDescription.setAttribute("property", "og:description");
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute(
      "content",
      "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
    );

    // Add viewport meta tag
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.head.appendChild(viewport);
    }
    viewport.setAttribute("content", "width=device-width, initial-scale=1");

    // Add theme-color meta tag
    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (!themeColor) {
      themeColor = document.createElement("meta");
      themeColor.name = "theme-color";
      document.head.appendChild(themeColor);
    }
    themeColor.setAttribute("content", "#000000");

    // Add Open Graph image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement("meta");
      ogImage.setAttribute("property", "og:image");
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute("content", `${process.env.PUBLIC_URL}/rw_logo.png`);

    // Add Open Graph type
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement("meta");
      ogType.setAttribute("property", "og:type");
      document.head.appendChild(ogType);
    }
    ogType.setAttribute("content", "website");

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = "https://randomwalk.ai/platform/";
  }, []);
 const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessemail, setEmailId] = useState("");
  const [projectdetails, setprojectdetails] = useState("");

  // const [utmSource, setUtmSource] = useState("");
  // const [utmMedium, setUtmMedium] = useState("");
  // const [utmCampaign, setUtmCampaign] = useState("");
  // const [utmId, setUtmId] = useState("");
  // const [utmTerm, setUtmTerm] = useState("");
  // const [utmContent, setUtmContent] = useState("");

  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_id: "",
    utm_term: "",
    utm_content: "",
  });
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setfirstname("");
    setlastname("");
    setPhoneNumber("");
    setCompanyName("");
    setEmailId("");
    setprojectdetails("");
    setIsChecked(true);
    setErrors({});
  };
  const handleButtonClickcontact = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      // Ensure number starts with +
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      // Check if the number is valid for the selected country
      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        // Get expected length based on country
        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);

  //   setUtmSource(searchParams.get("utm_source") || "");
  //   setUtmMedium(searchParams.get("utm_medium") || "");
  //   setUtmCampaign(searchParams.get("utm_campaign") || "");
  //   setUtmId(searchParams.get("utm_id") || "");
  //   setUtmTerm(searchParams.get("utm_term") || "");
  //   setUtmContent(searchParams.get("utm_content") || "");
  // }, []);


  useEffect(() => {
    const captureUtmParams = () => {
      console.log(utmContent);
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
      ];

      const newUtmParams = {
        utm_content: utmContent,
      };
      utmFields.forEach((field) => {
      
        newUtmParams[field] = params.get(field) || "";
      });
      console.log(newUtmParams);
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, [utmContent]);









  


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
  
    try {
      // Validate phone number first
      if (!phoneNumber) {
        setErrors({ phoneNumber: "Phone number is required" });
        setIsLoading(false);
        return;
      }
  
      const fullNumber = phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
  
      if (!isValidPhoneNumber(fullNumber)) {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
        setIsLoading(false);
        return;
      }

  
      const formData = {
        firstname,
        lastname,
        businessemail,
        companyName,
        phoneNumber,
        projectdetails,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
      };
  
      // First, save to Appwrite
      await Promise.all([
        databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          config.collectionIds.contactForm,
          ID.unique(),
          formData
        ),
    
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/submit-form`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }).then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to submit form');
          }
        }),
      ]);
  

      // Close the modal and show success message
      setIsModalOpen(false);
      setIsSuccessOpen(true);
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const location = useLocation();
useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }
}, [location]);





  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
  };

  const signupRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#signup") {
      signupRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const [isChecked, setIsChecked] = useState(true);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };


  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
        {
      title: "Business Enterprise Suite",
      icon: (
        <svg
                  className="w-10 h-10 text-blue-300"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M3 3v18h18" />
                  <path d="M18 17V9" />
                  <path d="M13 17V5" />
                  <path d="M8 17v-3" />
                </svg>
      ),
      description: "The Business Enterprise Suite brings together our flagship AI platforms - AI Readiness Assessment, Knowledge Nudge, Fortune Cookie, and Chateleon. Designed to drive learning, collaboration, and strategic decision-making. Together, they form the intelligence backbone for organizations ready to lead with AI.",
      features: [
        "Real-time Analytics, and teams",
        "Secure Data Processing",
        "Custom Dashboards",
        "Automated Reporting"
      ],
      benefits: [
        "Reduce decision-making time by 60%",
        "Ensure data security compliance",
        "Scale across enterprise"
      ]
    },
    {
      title: "AI Readiness Assessment",
      icon: (
        <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      description: "Most enterprises want AI - few know how ready they actually are. Our AI Readiness Assessment identifies organizational strengths, digital maturity, and capability gaps, giving you a clear roadmap for seamless AI adoption.",
      features: [
        "Comprehensive assessment across leadership, departments, and teams",
        "Instant insights to benchmark digital maturity",
        "Tailored recommendations for implementation and scaling"
      ],
      benefits: [
        "Know exactly where your AI journey stands",
        "Reduce risk and accelerate transformation",
        "Build confidence with data-backed readiness insights"
      ]
    },
    {
      title: "Knowledge Nudge",
      icon: (
        <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      description: "Knowledge transfer programs often fade fast. Employees forget most of what they learn within days. Knowledge Nudge keeps learning alive through AI-powered micro-assessments that reinforce knowledge, measure engagement, and improve retention.",
      features: [
        "Instantly converts training material into intelligent quizzes",
        "Tracks performance and learning progress over time",
        "Delivers continuous reinforcement through adaptive nudges"
      ],
      benefits: [
        "Boost long-term knowledge retention",
        "Improve employee performance and engagement",
        "Maximize ROI on learning and development initiatives"
      ]
    },
    {
      title: "Fortune Cookie",
      icon: (
        <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      description: "Organizations generate data daily but miss the hidden opportunities within. Fortune Cookie turns unstructured business data into meaningful insights. Helping the management, and teams visualize, anticipate trends, measure impact, and make faster decisions.",
      features: [
        "AI-driven data synthesis and pattern recognition",
        "Integrates with enterprise dashboards for live insights",
        "Customizable alerts and predictions for key metrics"
      ],
      benefits: [
        "Turn raw data into actionable intelligence",
        "Identify trends before they become challenges",
        "Empower every decision with data-driven clarity"
      ]
    },
    {
      title: "Chateleon",
      icon: (
        <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      description: "Chateleon isn't just about chatbots - it's about creating meaningful interactions. It empowers organizations to deploy secure, intelligent virtual AI Agents that understand context, automate tasks, and engage users naturally.",
      features: [
        "Multilingual, context-aware conversational capabilities",
        "Seamless integration with internal systems and CRMs",
        "Scalable and secure architecture for enterprise use"
      ],
      benefits: [
        "Enhance customer and employee experience",
        "Save time with automated, intelligent conversations",
        "Build trust with secure and reliable AI communication"
      ]
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="Main2 cus4:container cus4:mx-auto font-display">
    
      <section className="flex flex-col items-center font-poppins justify-center text-center min-h-full md:h-screen px-6 bg-bloghome mt-20 md:mt-0">
        <h2 className="text-4xl md:text-5xl 2xl:text-7xl font-extrabold text-[#3E59B7]  leading-[1.2] cursor-pointer">
Your AI Ecosystem, Evolved
        </h2>

        {/* Subtitle */}

        <p className="text-lg md:text-xl 2xl:text-3xl  text-[#545454] mt-4 font-poppins font-bold cursor-pointer ">
          Explore our suite of AI platforms engineered for performance, scalability, and trust. 
        
          <br />
          From enterprise automation to adaptive analytics, every platform is built to solve world challenges <br/>with precision and ingenuity.

        </p>

        <div className="flex flex-wrap gap-4 mt-10 items-center justify-center">
          <div className="flex items-center gap-3 rounded-full bg-[#3E59B7]  backdrop-blur-sm border border-white/20 px-5 py-3 text-white transition-all duration-300 ">
            <svg
              className="w-5 h-5 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <span className="text-sm font-medium whitespace-nowrap">
              Enterprise Security
            </span>
          </div>

          <div className="flex items-center gap-3 rounded-full bg-[#3E59B7]  backdrop-blur-sm border border-white/20 px-5 py-3 text-white transition-all duration-300 ">
            <svg
              className="w-5 h-5 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
            <span className="text-sm font-medium whitespace-nowrap">
              Real-time Processing
            </span>
          </div>

          <div className="flex items-center gap-3 rounded-full bg-[#3E59B7]  backdrop-blur-sm border border-white/20 px-5 py-3 text-white transition-all duration-300 ">
            <svg
              className="w-5 h-5 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-sm font-medium whitespace-nowrap">
              Scalable Solutions
            </span>
          </div>
        </div>
      </section>
    <div id="enterprise-bi"className="min-h-screen bg-white p-8 flex items-center justify-center">
      <div className="max-w-7xl w-full">
        <div className="relative">
          {/* Main Carousel Container */}
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left Content Section */}
            <div className="text-white space-y-8 px-10">
              <div className="flex items-center gap-4">
                <div className="bg-gradient-to-br from-[#4a5ba3] to-[#5d6bc4] rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
                  {slides[currentSlide].icon}
                </div>
                <div>
                  <h1 className="sm:text-lg md:text-2xl font-bold text-gray-800">
                    {slides[currentSlide].title}
                  </h1>
                </div>
              </div>

              {/* Description */}
              <p className="text-md text-[#666666] leading-relaxed">
                {slides[currentSlide].description}
              </p>

              {/* Key Features */}
              <div>
                <h2 className="text-xl font-bold mb-4 text-[#666666] text-left">
                  Key Features
                </h2>
                <div className="space-y-3">
                  {slides[currentSlide].features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <div className="w-2 h-2 bg-[#3E59B7] rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-[#666666]">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Business Benefits */}
              <div>
                <h2 className="text-xl font-bold mb-4 text-[#666666] text-left">
                  Business Benefits
                </h2>
                <div className="space-y-3">
                  {slides[currentSlide].benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <svg
                        className="w-5 h-5 text-[#3E59B7] flex-shrink-0"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                      <span className="text-[#666666]">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Buttons */}
              <div className="flex gap-4 pt-4">
                <button className="flex items-center gap-2 text-white bg-[#3E59B7] border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
                 onClick={handleButtonClickcontact}>
                  <span>Learn More</span>
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </button>
                <button className="border-2 border-[#3E59B7] text-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
                 onClick={handleButtonClickcontact}>
                  Book a Demo
                </button>
              </div>
            </div>

            {/* Right Visual Section */}
            <div className="relative hidden md:block">
              <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
                {/* Decorative circles */}
                <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
                <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>

                {/* Center Icon */}
                <div className="relative z-10 bg-gradient-to-br from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center transition-all duration-500">
                  {slides[currentSlide].icon}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-6 h-6 text-[#3E59B7]" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"
            aria-label="Next slide"
          >
            <ChevronRight className="w-6 h-6 text-[#3E59B7]" />
          </button>

          {/* Dot Indicators */}
          <div className="flex justify-center gap-2 mt-8">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentSlide === index
                    ? 'bg-[#3E59B7] w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>

      <div div id="Visualaiplatform" className="lg:min-h-screen bg-white p-8 flex items-center justify-center">
        <div className="md:max-w-7xl w-full grid md:grid-cols-2 md:gap-8 items-center">
          <div className="relative hidden md:block">
            <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
              {/* Decorative circles */}
              <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>

              {/* Center Icon */}
              <div className="relative z-10 bg-gradient-to-br from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center">
                <svg className="w-24 h-24 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              </div>
            </div>
          </div>
          <div className="text-white space-y-8">
            {/* Header with Icon */}
            <div className="flex items-center gap-4">
              <div className="bg-gradient-to-br from-[#4a5ba3] to-[#5d6bc4] rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
              <svg className="w-24 h-24 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              </div>
              <div>
                <h1 className="sm:text-lg md:text-2xl font-bold">Visual AI</h1>
                
              </div>
            </div>

            {/* Description */}
            <p className="text-md text-[#666666] leading-relaxed">
          Visual AI empowers enterprises to see patterns that humans can’t -` in real time, at scale, and with absolute precision. Whether it’s analyzing live video feeds, automating quality inspections, detecting anomalies, or enhancing security, our Visual AI platform interprets imagery with contextual intelligence.
It transforms visual data into operational insights that help organizations respond faster, reduce risk, and make smarter decisions every day.

            </p>

            {/* Key Features */}
            <div>
              <h2 className="text-md font-bold mb-4 text-[#666666] text-left">
                Key Features
              </h2>
              <div className="grid gap-2 items-start">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7]  rounded-full"></div>
                  <span className="text-[#666666] text-md">Advanced object detection, image classification, and video analytics.
</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7]  rounded-full"></div>
                  <span className="text-[#666666]">Edge and cloud-based deployment for real-time processing.</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7]  rounded-full"></div>
                  <span className="text-[#666666]">Custom-trained models adaptable to any business context.</span>
                </div>
           
              </div>
            </div>

            {/* Business Benefits */}
            <div>
              <h2 className="text-base font-bold mb-4 text-[#666666] text-left">
                Business Benefits
              </h2>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">
                    Automate complex visual workflows with accuracy.

                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">
                   Strengthen safety, compliance, and surveillance intelligence.

                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">Accelerate decision-making with actionable visual insights.
</span>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-4 pt-4">
              <button className="flex items-center gap-2 text-white  bg-[#3E59B7]   border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}>
                <span>Learn More</span>
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button className="border-2 border-[#3E59B7]  text-[#3E59B7]  font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
              onClick={handleButtonClickcontact}>
                Book a Demo
              </button>
            </div>
          </div>

          {/* Right Visual Section */}
        </div>
      </div>
      <div id="voiceai"className="lg:min-h-screen bg-white p-8 flex items-center justify-center">
        <div className="max-w-7xl w-full grid md:grid-cols-2 gap-8 items-center">
          {/* Left Content Section */}
          <div className="text-white space-y-8">
            {/* Header with Icon */}
            <div className="flex items-center gap-4">
              <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a] rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
               <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
              </div>
              <div>
                <h1 className="sm:text-lg md:text-2xl font-bold">
                  Voice AI

                </h1>
               
              </div>
            </div>

            {/* Description */}
            <p className="text-md text-[#666666] leading-relaxed">
               Voice AI bridges the gap between people and technology through natural, human-like interactions. From customer support and voice-enabled devices to enterprise communication tools, our Voice AI platform understands tone, emotion, and intent.
<br/>It enables organizations to deliver frictionless service experiences, automate repetitive interactions, and capture intelligence from every spoken word - securely and at scale.
            </p>

            {/* Key Features */}
            <div>
              <h2 className="text-xl font-bold mb-4 text-[#666666] text-left">
                Key Features
              </h2>
              <div className="grid items-start gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                  <span className="text-[#666666]">High-accuracy speech-to-text, text-to-speech, and intent detection.</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                  <span className="text-[#666666]">Multilingual models that adapt to regional dialects and contexts.
</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                  <span className="text-[#666666]">Sentiment and emotion analysis for customer experience optimization.</span>
                </div>
               
              </div>
            </div>

            {/* Business Benefits */}
            <div>
              <h2 className="text-xl font-bold mb-4 text-[#666666] text-left">Business Benefits</h2>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">
                  Deliver personalized and intuitive voice experiences.
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">
                  Increase efficiency by automating routine communication.

                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-[#3E59B7]"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span className="text-[#666666]">Gain customer insight from conversational analytics.
</span>
                </div>
              </div>
            </div>

            {/* Buttons */}
       <div className="flex gap-4 pt-4">
              <button className="flex items-center gap-2 text-white  bg-[#3E59B7]   border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}>
                <span>Learn More</span>
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button className="border-2 border-[#3E59B7]  text-[#3E59B7]  font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
              onClick={handleButtonClickcontact}>
                Book a Demo
              </button>
            </div>
          </div>

          {/* Right Visual Section */}
          <div className="relative hidden md:block">
            <div className="bg-gradient-to-br from-[#4a5ba3] to-[#5d6bc4] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
              {/* Decorative circles */}
              <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>

              {/* Center Icon */}
              <div className="relative z-10 bg-gradient-to-br from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center">
                  <svg className="w-24 h-24 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
              </div>
            </div>
          </div>
        </div>
      </div>


          <div  id="analyticalai" className="lg:min-h-screen bg-white p-8 flex items-center justify-center">
      <div className="max-w-7xl w-full grid md:grid-cols-2 gap-8 items-center">
        {/* Left Content Section */}





           <div className="relative hidden md:block">
          <div className="bg-gradient-to-br from-[#4a5ba3] to-[#5d6bc4] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>
            
            {/* Center Icon */}
            <div className="relative z-10 bg-gradient-to-br from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center">
              <svg className="w-24 h-24 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </div>
          </div>
        </div>
        <div className="text-white space-y-8">
          {/* Header with Icon */}
          <div className="flex items-center gap-4">
            <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a] rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
              <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </div>
            <div>
              <h1 className="sm:text-lg md:text-2xl font-bold">Analytical AI
</h1>
              
            </div>
          </div>

          {/* Description */}
          <p className="text-md text-[#666666] leading-relaxed">Analytical AI transforms complex datasets into strategic foresight. It doesn’t just analyze what happened - it predicts what comes next.
By integrating advanced machine learning models, predictive analytics, and visualization tools, our platform uncovers the patterns behind performance, risk, and opportunity. From finance to operations, Analytical AI brings clarity to the chaos of data.

          </p>

          {/* Key Features */}
          <div>
            <h2 className="text-md font-bold mb-4 text-[#666666] text-left">Key Features</h2>
            <div className="grid items-start gap-2">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Predictive modeling and prescriptive analytics.
</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">AI-driven anomaly detection and trend forecasting.
</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Interactive dashboards with real-time visualization.
</span>
              </div>
           
            </div>
          </div>

          {/* Business Benefits */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-[#666666] text-left">Business Benefits</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Make proactive, data-informed decisions.</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Identify growth opportunities and mitigate risks early.</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Strengthen strategic planning with AI-powered intelligence.</span>
              </div>
            </div>
          </div>

          {/* Buttons */}
            <div className="flex gap-4 pt-4">
              <button className="flex items-center gap-2 text-white  bg-[#3E59B7]   border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}>
                <span>Learn More</span>
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button className="border-2 border-[#3E59B7]  text-[#3E59B7]  font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
              onClick={handleButtonClickcontact}>
                Book a Demo
              </button>
            </div>
        </div>

        {/* Right Visual Section */}
     
      </div>
    </div>

      <div  id="textualai" className="lg:min-h-screen bg-white p-8 flex items-center justify-center">
      <div className="max-w-7xl w-full grid md:grid-cols-2 gap-8 items-center">
        {/* Left Content Section */}
        <div className="text-white space-y-8">
          {/* Header with Icon */}
          <div className="flex items-center gap-4">
            <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a] rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
              <svg className="w-10 h-10 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
            </div>
            <div>
              <h1 className="sm:text-lg md:text-2xl font-bold">Textual AI</h1>
              
            </div>
          </div>

          {/* Description */}
          <p className="text-md text-[#666666] leading-relaxed">
       Every enterprise generates millions of words through reports, messages, feedback, and documents. Textual AI brings structure and understanding to this unstructured world.<br/>
Using cutting-edge natural language processing (NLP) and generation models, our platform extracts meaning, sentiment, and context from text - empowering organizations to act on insights instantly and intelligently.

          </p>

          {/* Key Features */}
          <div>
            <h2 className="text-md font-bold mb-4 text-[#666666] text-left">Key Features</h2>
            <div className="grid  gap-2 items-start">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Automated text summarization, classification, and translation.
</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Contextual understanding of tone, intent, and sentiment.</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Scalable NLP models for enterprise data ecosystems.
</span>
              </div>
     
            </div>
          </div>

          {/* Business Benefits */}
          <div>
            <h2 className="text-md font-bold mb-4 text-[#666666] text-left">Business Benefits</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Unlock insights from internal and customer communication.
</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Streamline reporting, content creation, and monitoring.
</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Enhance decision-making through contextual text intelligence.
</span>
              </div>
            </div>
          </div>

          {/* Buttons */}
               <div className="flex gap-4 pt-4">
              <button className="flex items-center gap-2 text-white  bg-[#3E59B7]   border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}>
                <span>Learn More</span>
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button className="border-2 border-[#3E59B7]  text-[#3E59B7]  font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
              onClick={handleButtonClickcontact}>
                Book a Demo
              </button>
            </div>
        </div>

        {/* Right Visual Section */}
        <div className="relative hidden md:block">
          <div className="bg-gradient-to-br  from-[#4a5ba3] to-[#5d6bc4] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>
            
            {/* Center Icon */}
            <div className="relative z-10 bg-gradient-to-br from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center">
              <svg className="w-24 h-24 text-blue-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>


 <div id ="functionaliai"className="lg:min-h-screen bg-white p-8 flex items-center justify-center">
      <div className="max-w-7xl w-full grid md:grid-cols-2 gap-8 items-center">
        {/* Left Content Section */}

          <div className="relative hidden md:block">
          <div className="bg-gradient-to-br from-[#4a5ba3] to-[#5d6bc4] rounded-3xl p-12 min-h-[600px] flex items-center justify-center relative overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 left-20 w-48 h-48 bg-blue-300/10 rounded-full blur-3xl"></div>
            
            {/* Center Icon */}
            <div className="relative z-10 bg-gradient-to-br  from-[#5d6fc4] to-[#4a5ba3] rounded-full p-12 w-48 h-48 flex items-center justify-center">
              <svg         xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={1.8}
      stroke="#93C5FD"
      className="w-32 h-32">
            <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3C12 3 9 3 7.5 4.5C6 6 6 8 6 9.5C6 9.5 5 10 5 11.5C5 13 6 13.5 6 13.5C6 13.5 5.5 15 6.5 16.5C7.5 18 9 19 10.5 19.5"
      />
      {/* Right hemisphere */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3C12 3 15 3 16.5 4.5C18 6 18 8 18 9.5C18 9.5 19 10 19 11.5C19 13 18 13.5 18 13.5C18 13.5 18.5 15 17.5 16.5C16.5 18 15 19 13.5 19.5"
      />
      {/* Center line */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3V21"
      />
      {/* Left details */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 7C7.5 7 8.5 7.5 8.5 9M7 11C7 11 8 11.5 9 12M7.5 15C7.5 15 9 15.5 10 16"
      />
      {/* Right details */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 7C16.5 7 15.5 7.5 15.5 9M17 11C17 11 16 11.5 15 12M16.5 15C16.5 15 15 15.5 14 16"
      />
              </svg>
            </div>
          </div>
        </div>
        <div className="text-white space-y-8">
          {/* Header with Icon */}
          <div className="flex items-center gap-4">
            <div className="bg-gradient-to-br from-[#4a5ba3] to-[#3a4a8a]  rounded-2xl p-4 w-20 h-20 flex items-center justify-center">
              <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={1.8}
      stroke="#93C5FD"
      className="w-10 h-10"
    >
                 <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3C12 3 9 3 7.5 4.5C6 6 6 8 6 9.5C6 9.5 5 10 5 11.5C5 13 6 13.5 6 13.5C6 13.5 5.5 15 6.5 16.5C7.5 18 9 19 10.5 19.5"
      />
      {/* Right hemisphere */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3C12 3 15 3 16.5 4.5C18 6 18 8 18 9.5C18 9.5 19 10 19 11.5C19 13 18 13.5 18 13.5C18 13.5 18.5 15 17.5 16.5C16.5 18 15 19 13.5 19.5"
      />
      {/* Center line */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3V21"
      />
      {/* Left details */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 7C7.5 7 8.5 7.5 8.5 9M7 11C7 11 8 11.5 9 12M7.5 15C7.5 15 9 15.5 10 16"
      />
      {/* Right details */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 7C16.5 7 15.5 7.5 15.5 9M17 11C17 11 16 11.5 15 12M16.5 15C16.5 15 15 15.5 14 16"
      />
              </svg>
            </div>
            <div>
              <h1 className="sm:text-lg md:text-2xl font-bold">Functional AI
</h1>
              
            </div>
          </div>

          {/* Description */}
          <p className="text-md text-[#666666] leading-relaxed">
           Functional AI is where intelligence meets execution. It’s designed to automate workflows, optimize processes, and orchestrate smarter operations across every department.<br/>
From supply chain and HR to finance and customer success, Functional AI learns from performance patterns to enhance productivity and ensure systems run efficiently - with minimal human intervention and maximum reliability.

          </p>

          {/* Key Features */}
          <div>
            <h2 className="text-md font-bold mb-4 text-[#666666] text-left">Key Features</h2>
            <div className="grid  gap-2 items-start">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Intelligent process automation and adaptive task routing.
</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">AI-based decision support and process optimization.
</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-[#3E59B7] rounded-full"></div>
                <span className="text-[#666666]">Seamless integration with enterprise applications and APIs</span>
              </div>
             
            </div>
          </div>

          {/* Business Benefits */}
          <div>
            <h2 className="text-md font-bold mb-4 text-[#666666] text-left">Business Benefits</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Streamline operations through intelligent automation.</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Improve accuracy, speed, and consistency in execution.
</span>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-[#3E59B7]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
                <span className="text-[#666666]">Free up human capital for higher-value strategic tasks.
</span>
              </div>
            </div>
          </div>

          {/* Buttons */}
            <div className="flex gap-4 pt-4">
              <button className="flex items-center gap-2 text-white  bg-[#3E59B7]   border-2 border-[#3E59B7] font-semibold px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}>
                <span>Learn More</span>
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button className="border-2 border-[#3E59B7]  text-[#3E59B7]  font-semibold px-6 py-3 rounded-lg hover:bg-[#3E59B7]/10 transition-all duration-300"
              onClick={handleButtonClickcontact}>
                Book a Demo
              </button>
            </div>
        </div>

        {/* Right Visual Section */}
      
      </div>
    </div>
  
  <section
          className="text-[#666666] min-h-[180px] md:min-h-[230px] relative mt-20 bg-no-repeat bg-cover"
          style={{
            background: "linear-gradient(100deg , #3E59B7 90%, #A6BAFF 110%)", // Example pink gradient
          }}
        >
          <figure className="absolute bottom-0 right-0">
            <img
              src={recright}
              alt="Additional"
              loading="lazy"
              className="lg:w-40 lg:h-auto w-24 h-36 md:w-40 md:h-full"
            />
          </figure>
          <article className="absolute  inset-0 flex flex-col justify-center items-center text-center text-white pt-4 md:pt-10 md:mr-32 lg:pt-5 md:ml-20 ">
            <h2 className="md:text-xl lg:text-2xl text-sm font-bold mb-4 font-display">
           Ready to Experience Our AI Platforms?
            </h2>
            <p className="md:text-lg lg:text-lg text-sm font-light mb-4 font-display mx-2 ">
          Discover how our comprehensive AI platform suite can transform your <br/>enterprise operations and drive unprecedented growth.
            </p>

       <div className="flex gap-4 ">
  <button
    className="md:mt-3 mb-3 rounded-xl border text-[#3E59B7] bg-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out hover:bg-transparent hover:border hover:border-white hover:text-[#FFFFFF]"
   onClick={handleButtonClickcontact}
  >
    <div className="flex items-center">
      <span className="text-xs md:text-lg font-bold">Start Free Trial</span>
    </div>
  </button>

  <button
    className="md:mt-3 mb-3 rounded-xl border text-white border-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out bg-transparent hover:bg-white hover:text-[#3E59B7]"
  onClick={handleButtonClickcontact}
  >
    <div className="flex items-center">
      <span className="text-xs md:text-lg font-bold">Schedule Demo
      </span>
    </div>
  </button> 
</div>
          </article>
        </section>
     {isModalOpen && (
          <section className="fixed z-50 inset-0 md:p-0 lg:px-20 p-12  bg-black bg-opacity-50 flex items-center justify-center">
            <div className="relative bg-[#F1F6FF]   p-8 lg:px-10 rounded-lg max-h-screen   max-w-md w-full">
              <a
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
              >
                <svg
                  className="lg:w-6 lg:h-6 w-4 h-4 cursor-pointer"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              {/* <div className='text-lg md:text-xl text-center font-bold mb-4'>
                  Experience the Power of Data <br />
                  With
                  <span className='text-[#C62B6D] font-bold'> AI Fortune </span>
                  Cookie
                </div> */}
              <form onSubmit={handleSubmit}>
              <div className="max-h-[400px] overflow-y-auto custom-scrollbar pr-4 ">
                <div className="mb-2">
                  <label className=" text-gray-700">First Name</label>
                  <input
                    id="firstname"
                    type="text"
                    name="firstname"
                    value={firstname}
                    onChange={(e) => setfirstname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.firstname && (
                    <p className="text-red-500 text-sm">{errors.firstname}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className=" text-gray-700">Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    id="lastname3"
                    value={lastname}
                    onChange={(e) => setlastname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.lastname && (
                    <p className="text-red-500 text-sm">{errors.lastname}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label id="Phonenumber" className=" text-gray-700">
                    Phone Number
                  </label>
                  <PhoneInput
                    country={"in"}
                    value={phoneNumber}
                    onChange={(number, country) =>
                      handlePhoneNumberChange(number, country)
                    }
                    inputClass="custom-phone-input2 "
                    buttonClass="border rounded"
                    dropdownClass="border rounded"
                    required
                    enableSearch={true}
                    inputProps={{
                      required: true,
                      autoFocus: false,
                    }}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className="text-gray-700">Company Name</label>
                  <input
                    id="Companyname"
                    type="text"
                    name="companyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className=" text-gray-700">Business Email</label>
                  <input
                    id="businessemail"
                    type="email"
                    name="businessemail"
                    value={businessemail}
                    onChange={(e) => setEmailId(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.businessemail && (
                    <p className="text-red-500 text-sm">
                      {errors.businessemail}
                    </p>
                  )}
                </div>
 
                <div className="mb-4">
                  <label className=" text-gray-700">
                    Project Details(Optional)
                  </label>
                  <input
                    id="projectdetails"
                    type="text"
                    name="projectdetails"
                    value={projectdetails}
                    onChange={(e) => setprojectdetails(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="disclaimerContainercontact">
                  <label className="checkboxLabel">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="checkbox"
                    />
                    <span className="checkboxText">
                      I agree and authorize team to contact me and/or send
                      relevant information over Email, SMS & WhatsApp. This will
                      override the registry with DNC/NDNC.
                    </span>
                  </label>
                </div>
                {errors.terms && (
                  <p className="text-red-500 text-sm">{errors.terms}</p>
                )}
                <div className="linksContainer">
                  <a href="/terms-of-service/" className="link">
                    Terms of Service
                  </a>
                  <a href="/privacy-policy/" className="link">
                    Privacy Policy
                  </a>
                </div>
                  </div>
                  <div className="mb-4">
  <button
    id="submit"
    type="submit"
    className={`w-full px-4 py-2 bg-[#C62B6D] text-white rounded ${
      !isChecked || isLoading ? "opacity-50 cursor-not-allowed" : ""
    }`}
    disabled={!isChecked || isLoading}
  >
    {isLoading ? (
      <div className="flex items-center justify-center space-x-2">
        <svg
          className="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <span>Submitting...</span>
      </div>
    ) : (
      "Submit"
    )}
  </button>
</div>
              </form>
            </div>
          </section>
        )}
         {isSuccessOpen && (
          <section className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
              <a
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeSuccessModal}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              <h2 className="text-2xl font-bold mb-4">Success!</h2>
              <p className="mb-4">Your request has been sent successfully.</p>
              <button
                id="close"
                className="px-4 py-2 bg-[#C62B6D] text-white rounded"
                onClick={closeSuccessModal}
              >
                Close
              </button>
            </div>
          </section>
        )}
   
    </div>
  );
};

export default Platform;
